import React from 'react'

require('./dataset.css')

class DataCollectionListSummaryTableHeader extends React.Component {
  render() {
    return (
      <thead>
        <tr>
          <th className="borderedCell" rowSpan={2}>
            Run
          </th>
          <th className="borderedCell" rowSpan={2}>
            Sample
          </th>
          <th className="borderedCell" rowSpan={2}>
            <div>
              Frames <br /> (avg&nbsp;/&nbsp;tot)
            </div>
          </th>
          <th className="borderedCell" colSpan={3}>
            Guinier
          </th>
          <th className="borderedCell" colSpan={3}>
            Gnom
          </th>
          <th className="borderedCell" colSpan={2}>
            Porod
          </th>
          <th className="borderedCell" rowSpan={2}>
            Scattering
          </th>
          <th className="borderedCell" rowSpan={2}>
            Kratkty
          </th>
          <th className="borderedCell" rowSpan={2}>
            P(r)
          </th>
          <th className="borderedCell" rowSpan={2}>
            Guinier
          </th>
          <th className="borderedCell" rowSpan={2}>
            Advanced
          </th>
        </tr>
        <tr>
          <th className="borderedCell">Rg</th>
          <th className="borderedCell">Points</th>
          <th className="borderedCell">I0</th>
          <th className="borderedCell">Rg</th>
          <th className="borderedCell">Total</th>
          <th className="borderedCell">
            D<sub>max</sub>
          </th>
          <th className="borderedCell">Volume</th>
          <th className="borderedCell">MM. Vol. est.</th>
        </tr>
      </thead>
    )
  }
}

export default DataCollectionListSummaryTableHeader
